import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

const MAX_CHARACTER_COUNT = 500;

export class CommentsField extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    value: PropTypes.string,
    isProductFeedbackLoop: PropTypes.bool,
    isAccountSettings: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    onFocus: _.noop,
    isProductFeedbackLoop: false,
    isAccountSettings: false,
  };

  handleChange = (e) => {
    const { onChange } = this.props;
    onChange(e.target.value.substring(0, MAX_CHARACTER_COUNT));
  };

  render() {
    const {
      id,
      i18n,
      value,
      isProductFeedbackLoop,
      isAccountSettings,
    } = this.props;

    const characterCount = isAccountSettings ?
      `${value.length} / ${MAX_CHARACTER_COUNT}`
      : i18n.getString('Recommendation_Feedback_ReasonNoteCharacterCount', {
        characterCount: value.length,
        maxCharacterCount: MAX_CHARACTER_COUNT,
      });

    const placeHolder = isProductFeedbackLoop ?
      i18n.getString('Recommendation_Product_Feedback_Loop_Comments_Placeholder')
      : i18n.getString('Recommendation_Feedback_Comments_Placeholder');

    return (
      <div>
        <textarea
          id={id}
          className="form-control"
          placeholder={placeHolder}
          onChange={this.handleChange}
          value={value}
          onFocus={this.props.onFocus}
        />
        <div className="comments-character-count">{ characterCount }</div>
      </div>
    );
  }
}
